export default __webpack_public_path__ + "static/media/1863.1079e866.png";